import { Button, Dots, Dot } from './MenuButton.styles'
import type { MenuButtonProps } from './MenuButton.types'

const MenuButton = ({ onClick, isOpen, dataTestId }: MenuButtonProps) => (
    <Button
        onClick={onClick}
        type="button"
        isOpen={isOpen}
        data-testid={dataTestId}
    >
        <Dots>
            <Dot />
            <Dot />
            <Dot />
        </Dots>
    </Button>
)

export default MenuButton
